import SodAccessPath from './SodAccessPath';

export default SodAccessPath;
